import React from "react";

import { CloseWhiteIcon } from "../../assets/icons";

interface ImageModalProps {
    url: string;
    altText?: string;
    onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ url, altText, onClose }) => {
    return (
        <section className="image-modal-section" onClick={onClose}>
            <div className="w-layout-blockcontainer container w-container">
                <div className="image-modal-wrapper">
                    <div className="image-modal-image-div" >
                        <img src={url} alt={altText} className="image-modal-image" onClick={(e) => e.stopPropagation()} />
                        {/* <img src={CloseWhiteIcon} alt="Close" className="icon-size-28 absolut-top-pleft close" onClick={onClose} /> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImageModal;